import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

import { ShareSocial } from './components/ShareSocial';
import { ShareUrl } from './components/ShareUrl';
import { ShareYourPetition as ShareYourPetitionReskin } from './index_new';

export type WindowWithOptimizely =
	| (Window &
			typeof globalThis & {
				optimizely?: {
					push: (args: object) => void;
				};
			})
	| undefined;

export function ShareYourPetition(): JSX.Element {
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();
	if (isEnabled) {
		return <ShareYourPetitionReskin />;
	}
	return (
		<Card
			id="share_module"
			p="24px"
			backgroundColor="white"
			data-testid="share_module-control"
			sx={{
				border: 'unset',
				borderRadius: 'big',
			}}
		>
			<Heading as="h3" size="h4" id="share-petition-title">
				<Translate value="corgi.petition.starter_dashboard.grow_petition.share_petition.title" />
			</Heading>
			<Text as="p" mt="16px">
				<Translate value="corgi.petition.starter_dashboard.grow_petition.share_petition.description" />
			</Text>
			<Flex sx={{ gap: '16px', mt: '24px', flexWrap: 'wrap' }}>
				<ShareUrl />
				<ShareSocial />
			</Flex>
		</Card>
	);
}
